var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "building_svg__buildings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 550",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes buildings-s-path1_to__to{0%{transform:translate(377.629116px,816.849979px);animation-timing-function:cubic-bezier(.42,0,.58,1)}to{transform:translate(377.63px,325.861734px)}}@keyframes buildings-s-path2_to__to{0%{transform:translate(159.87909px,869.350009px)}18.181818%{transform:translate(159.87909px,869.350009px);animation-timing-function:cubic-bezier(.42,0,.58,1)}to{transform:translate(160.199989px,377.061764px)}}")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.63 816.85)",
    style: {
      animation: "buildings-s-path1_to__to 2200ms linear 1 normal forwards"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "building_svg__buildings-s-path1",
    d: "M271.5 194.9v-49.3l69.5-27.4v384.3h210.4V132.8l-204.9-64L233.1 120v61.9M411 334.7l-38.4-9.7v-56.3l38.4 9.7v56.3zm0-72l-38.4-9.7v-56.3l38.4 9.7v56.3zm0-71l-38.4-9.7v-56.3l38.4 9.7v56.3zm57.7 156.2l-34.4-8.9v-56.1l34.4 8.9v56.1zm0-72.8l-34.4-8.9v-51.6l34.4 8.9v51.6zm0-72.8l-34.4-8.9v-51.6l34.4 8.9v51.6zm57.7 159.8l-34.4-8.9v-56.1l34.4 8.9v56.1zm0-72.8l-34.4-8.9v-51.6l34.4 8.9v51.6zm0-72.8l-34.4-8.9V156l34.4 8.9v51.6z",
    transform: "translate(-392.25 -285.65)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.88 869.35)",
    style: {
      animation: "buildings-s-path2_to__to 2200ms linear 1 normal forwards"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "building_svg__buildings-s-path2",
    d: "M157.6 172.5L71 211.7v102l-36.3 37.7v152.4h28.7V357l37-37.7v-88.1l53.1-21v293.5h160.8V221.4l-156.7-48.9zm49.3 203.2l-29.4-7.4v-43l29.4 7.4v43zm0-55l-29.4-7.4v-43l29.4 7.4v43zm0-54.2l-29.4-7.4v-43l29.4 7.4v43zM251 385.8l-26.3-6.8v-42.8L251 343v42.8zm0-55.6l-26.3-6.8V284l26.3 6.8v39.4zm0-55.7l-26.3-6.8v-39.4l26.3 6.8v39.4zm44 122.1l-26.3-6.8V347l26.3 6.8v42.8zm0-55.6l-26.3-6.8v-39.4l26.3 6.8V341zm0-55.6l-26.3-6.8v-39.4L295 246v39.4z",
    transform: "translate(-174.5 -338.15)",
    fill: "#690"
  }))));
}

export default __webpack_public_path__ + "82664cca0270bfeb977d063e46686fb4.svg";
export { SvgBuilding as ReactComponent };